import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutZoneAreaLookup extends Layout {
}
